import { EnvironmentDirectory } from '../app/shared/env-switcher';

// Bundled fallback used by both RemoteConfigService (post-bootstrap) and the
// pre-bootstrap gate in main.ts, in case the `environment_directory` Remote
// Config parameter can't be fetched (offline, first load before RC has ever
// synced, etc). Only "dev" is guaranteed - it mirrors environment.dev.ts.
export const FALLBACK_ENVIRONMENT_DIRECTORY: EnvironmentDirectory = {
  dev: {
    baseUrl: 'https://dev-api.eshyft.com/api/v2',
    webHost: 'dev.eshyft.com',
    firebaseTenantId: 'dev-main-0h5r6',
  },
};
